import React, {  Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { browserHistory } from 'react-router';
// import moment from 'moment';
import 'moment-timezone';
import * as messageConstants from '../../common/messageConstants';
import moment from 'moment';

import { processPricingResponse } from '../../../redux/util';

import ChangeZipCode from '../common/changeZipCode';

/* dialog */
import AccountNumberAutoSuggests from '../common/accountNumberAutoSuggestsAvailPricing';
import GenericOverlayDialog from '../../dialogs/genericOverlayDialog';
import ProductsInTheCartOverlayDialog from '../../dialogs/productsInTheCartOverlayDialog';
import ImportFileConfirmOverlayDialog from '../../dialogs/importFileConfirmOverlayDialog';
import ToolTipOverlayDialog from '../../dialogs/toolTipOverlayDialog';
/* Actions */
import {
	getPriceOrder,
	getPIMItemInfo,
	saveCreateOrderPayload,
	saveAvailabilityOnChangeAddress,
	getOrderList,
    saveBookedOrders,
	getBillingReferences,
    saveBillingReferences,
	getShippingMethod,
	addToCart,
	saveToCart,
	getProductsFromS3,
	saveAvailabilityPricingOfImportedFile,
	checkPricesForSearchResult,
	saveQuickOrderData,
	resetErrorLog,
	getSearchKeywordSuggestionList,
	saveCreateOrderPayloadBackup,
} from '../../../redux/actions';

import { DATE_TIME_FORMAT } from '../../common/messageConstants';
import { routes } from '../../../redux/api/routes';
const { s3BucketAPIBaseURL } = routes;

class QuickOrderForm extends Component {

	constructor(props) {
		super(props);
        this.state = {
			updateState: true,
			pimDataByItem: [],
			errorMessage: "",
			defaultAddressId: '00000',
            isDataValid : true,
            //set default products
            products: null,
			pointValue: 0.00,
			orderWeight: 0.00,

			// using below flags to maintain status of parallel calls before redirecting to create order page
			isAvailabilityCallCompleted: false,
	        isPricingCallCompleted: false,
	        isPimCallCompleted: false,
			isShippingMethodCompleted: false,
			availabilityData: null,
	        pricingData: null,
	        pimData: null,

			availabilityDataImportedFile: null,
	        pricingDataImportedFile: null,
	        pimDataImportedFile: null,

			last30DaysOrders: null,
			last60DaysOrders: null,
			isLast30DaysOrdersCompleted: false,
			isLast60DaysOrdersCompleted: false,

			productsPayload: [],

			showImportFileConfirmOverlayDialog: false,
			showProductsInTheCartOverlayDialog: false,
			showGenericOverlayDialog: false,
			genericDialogHeading: '',
            genericDialogText: '',
            modalButtons: '',

			fileUploadStatusMessage: '',
			fileUploadStatus: false,
			fileUploadErrorMessage: '',

			invalidPONumberMessage: 'PO number cannot include  `,~, | , * , >, <,  or /',
			showToolTipOverlayDialog: false,
        };
		this.setChangeMethod = [];
		this.anyRestrictedItemsAdded = this.anyRestrictedItemsAdded.bind(this);
		this.checkAvailabilityAndAll = this.checkAvailabilityAndAll.bind(this);
		this.handleDialog = this.handleDialog.bind(this);
		this.handleAddToCart = this.handleAddToCart.bind(this);
		this.updateOrderPoints = this.updateOrderPoints.bind(this);
		this.validateFP = this.validateFP.bind(this);
		this.validateFDD = this.validateFDD.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.onChangePONumber = this.onChangePONumber.bind(this);
		this.getSelectedAddressParams = this.getSelectedAddressParams.bind(this);
	}

	handleAddToCart(items) {
		const self = this,
			{ selectedAccount, userDetails } = self.props.state.user;
		let payload = {
			accountNumber: selectedAccount.ACCOUNTNUMBER,
			createdDate: moment().format('MM/DD/YYYY'),
			updatedDate: moment().format('MM/DD/YYYY'),
			userId: userDetails.sso,
			cartItems: items
		};
		self.props.addToCart(payload, response => {
			if (response.status && response.responseObject) {
				self.props.saveToCart(response);
				self.setState({
					isAvailabilityCallCompleted: false,
					availabilityData: null
				}, () => {
					self.handleCreateOrder();
				})
			} else {
				 
				browserHistory.push('/error');
			}
		});
	}

	howToHandleCartItems(action) {
		const self = this;
		// updated items is payload for add to cart
		let updatedItems = [];
		// this is the payload for create order
		const productsPayloadForCreateOrder = [];
		if(action === 'combine') {
			// Update updated items with existing items from cart and then add items of quick orders
			updatedItems = JSON.parse(JSON.stringify(self.props.state.cart.cart.responseObject.cartItems));
			if(updatedItems && updatedItems.find(itm => itm.orderNumber)) {
				self.props.checkForBackOrders(self.props.getSelectedAccountNumber(), true, (response) => {
					self.setState({
						backOrders: response.responseObject || [],
						backOrderCallCompleted: true
					}, () => {
						self.callBackAfterCallsCompleted();
					});
				});
				self.props.checkForBulkOrdersHold(self.props.getSelectedAccountNumber(), true, (response) => {
					self.setState({
						bulkOrders: response.responseObject || [],
						bulkOrderHoldCallCompleted: true
					}, () => {
						self.callBackAfterCallsCompleted();
					});
				});
			} else {
				// if there are not back orders items then continue as it is by adding all items of the cart with newly added items on quick order
				self.appendCartItemsCallBack();
			}
		} else if(action === 'delete') {
			const products = [];
			if (self.props.state.cart && self.props.state.cart.cart &&
				self.props.state.cart.cart.responseObject && self.props.state.cart.cart.responseObject.cartItems &&
				self.props.state.cart.cart.responseObject.cartItems.length
			) {
				self.props.state.cart.cart.responseObject.cartItems.forEach(item => {
					products.push({
						name: item.itemDescription,
						id: item.item,
						price: undefined, // TBD
						brand: undefined, // TBD
						category: undefined, // TBD
						variant: undefined,
						quantity: item.quantity,
						dimension70: item.quantity > item.availability ? 'yes' : 'no',
					});
				});
			}
			// Fire gtm tag of Remove from cart for existing items
			self.props.fireGTMTag('Remove from Cart', {
				ecommerce: {
					currencyCode: 'USD',
					remove: {
						products
					}
				}
			});
			self.setState({
				updatedItems,
				productsPayloadForCreateOrder
			}, () => {
				self.handleContinueCreateOrder();
			});
		}
	}

	appendCartItemsCallBack() {
		const self = this;
		// Update updated items with existing items from cart and then add items of quick orders
		const updatedItems = JSON.parse(JSON.stringify(self.props.state.cart.cart.responseObject.cartItems));
		const productsPayloadForCreateOrder = [];
		const { backOrders, bulkOrders } = self.state;
		// update payload for create order from the cart with already added items into cart
		self.props.state.cart.cart.responseObject.cartItems.forEach(item => {
			let orderLineNumber = '';
			let orderLineId = '';
			if (item.orderNumber) {
				const backOrder = backOrders.find(itm => itm.orderHeader.orderNumber === item.orderNumber);
				// Now onwards we will have orderLineId in cart items so we will use that to find item details by orderLineId
				let itemDetails = backOrder && backOrder.orderDetail && backOrder.orderDetail.orderLine.find(itm => {
					return item.orderLineId && item.orderLineId === itm.orderLineId && itm.lineStatus.toLowerCase() !== 'cancelled'
				});
				// For temporary purpose we are keeping below existing logic, We can remove it after sometime
				if (!itemDetails) {
				    const bulkOrder = bulkOrders.find(itm => itm.orderHeader.orderNumber === item.orderNumber);
				    // Now onwards we will have orderLineId in cart items so we will use that to find item details by orderLineId
				    itemDetails = bulkOrder && bulkOrder.orderDetail && bulkOrder.orderDetail.orderLine.find(itm => {
				        return item.orderLineId && item.orderLineId === itm.orderLineId && itm.lineStatus.toLowerCase() !== 'cancelled'
				    });
				}
				// if item details available for disabled quantity in cart then only we have to consider that product to keep in cart else ignore that item from cart
				if(itemDetails) {
					// This can be used once user click on create order as we r removing dependencies of order details parallel calls
					orderLineNumber = `${itemDetails.lineNum}.${itemDetails.shipmentNum}`;
					orderLineId = itemDetails.orderLineId;
				}
			}
			productsPayloadForCreateOrder.push({
				packageName: item.packageName ? item.packageName.toUpperCase() : '',
				productName: item.item,
				qty: item.quantity,
				productDetails: {
					availabilityData: [{
						itemType: item.itemType,
					}],
					description: item.itemDescription,
					imagePath: item.imagePath
				},
				agreementNumber: item.agreementNumber,
				qtyError: false,
				agreementNumberError: false,
				keepOriginalPO: item.keepOriginalPO,
				keepOriginalPrice: item.keepOriginalPrice,
				orderDate: item.orderDate,
				orderNumber: item.orderNumber,
				lineNumber: orderLineNumber,
				poNumber: item.poNumber,
				orderLineId: orderLineId,
				overpackQuantityRequired : item.overpackQuantityRequired,
				packageQuantity:item.packageQuantity
			});
		});
		self.setState({
			updatedItems,
			productsPayloadForCreateOrder
		}, () => {
			self.handleContinueCreateOrder();
		});
	}

	verifyBackOrders(backOrders, callback) {
		const self = this,
			{ selectedAccount, userDetails } = self.props.state.user;
		// if any item is having order number check below criteria from those items which is having orderNumber
		// 1. if any items whose backOrders quantity is 0 then delete that item from cart
		// 2. if any item is having quantity > backOrders quantity then update cart with backOrders quantity for that particular item
		// 3. in other scenario no change in cart
		const cartItems = [];
		let anyChangeRequiredInCart = false;
		self.props.state.cart.cart.responseObject && self.props.state.cart.cart.responseObject.cartItems.forEach((item) => {
			if(item.orderNumber) {
				const backOrder = backOrders.find(itm => itm.orderHeader.orderNumber === item.orderNumber);
				// Now onwards we will have orderLineId in cart items so we will use that to find item details by orderLineId
				let itemDetails = backOrder && backOrder.orderDetail && backOrder.orderDetail.orderLine.find(itm => {
					return item.orderLineId && item.orderLineId === itm.orderLineId && itm.lineStatus.toLowerCase() !== 'cancelled'
				});
				// For temporary purpose we are keeping below existing logic, We can remove it after sometime
				if (!itemDetails) {
					itemDetails = backOrder && backOrder.orderDetail && backOrder.orderDetail.orderLine.find(itm =>
						itm.item === item.item && itm.lineStatus.toLowerCase() !== 'cancelled'
					);
				}
				// if item details available for disabled quantity in cart then only we have to consider that product to keep in cart else ignore that item from cart
				if(itemDetails) {
					// This can be used once user click on create order as we r removing dependencies of order details parallel calls
					item.orderLineNumber = `${itemDetails.lineNum}.${itemDetails.shipmentNum}`
					// 1. if any items whose backOrders quantity is 0 then delete that item from cart
					// So we will only set flag but not add that particular item in cartItems for payload
					if(itemDetails.orderedQty === 0) {
						anyChangeRequiredInCart = true;
					} else if(item.quantity > itemDetails.orderedQty) {
						anyChangeRequiredInCart = true;
						cartItems.push({
							...item,
							quantity: itemDetails.orderedQty
						});
					} else {
						cartItems.push(item);
					}
				}
			} else {
				cartItems.push(item);
			}
		});
		if(anyChangeRequiredInCart) {
			let payload = {
				accountNumber: selectedAccount.ACCOUNTNUMBER,
				createdDate: moment().format('MM/DD/YYYY'),
				updatedDate: moment().format('MM/DD/YYYY'),
				userId: userDetails.sso,
				cartItems
			};
			this.props.addToCart(payload, response => {
				if (response.status && response.responseObject) {
					self.props.saveToCart(response);
					callback && callback();
				} else {
					 
					browserHistory.push('/error');
				}
			});
		} else {
			callback && callback();
		}
	}

	callBackAfterCallsCompleted() {
		const self = this;
		const { backOrderCallCompleted, bulkOrderHoldCallCompleted, backOrders, bulkOrders } = self.state;
		if(backOrderCallCompleted && bulkOrderHoldCallCompleted) {
			self.verifyBackOrders(backOrders.concat(bulkOrders), () => {
				let orderNumbers = [];
				self.props.state.cart.cart.responseObject.cartItems.forEach(item => {
					if (item.orderNumber) {
						orderNumbers.push(item.orderNumber);
					}
				});
				orderNumbers = _.uniq(orderNumbers);
				if (orderNumbers.length) {
					self.props.getOrderDetailsInParallelBatches(orderNumbers, () => {
						self.appendCartItemsCallBack();
					});
				} else {
					self.appendCartItemsCallBack();
				}
			});
		}
	}

	handleContinueCreateOrder() {
		const self = this;
		const {
			updatedItems,
			productsPayloadForCreateOrder
		} = self.state;
		const products = self.state.products;
		const productsForGTMAddToCart = [];
		products.forEach(item => {
			if(!item.isDelete && item.productName && item.productDetails) {
				updatedItems.push({
		            itemType: item.itemType || item.productDetails.availabilityData[0].itemType,
		            item: item.productName,
		            quantity: item.qty,
		            itemDescription: item.productDetails.description,
					agreementNumber: item.agreementNumber,
					createdDate: moment().format(DATE_TIME_FORMAT),
					updatedDate: moment().format(DATE_TIME_FORMAT),
					imagePath:  item.productDetails.imagePath||item.imagePath,
					overpackQuantityRequired: (item.productDetails && item.productDetails.overpackQuantityRequired) ||item.overpackQuantityRequired,
					packageQuantity: item.productDetails.packageQuantity || item.packageQuantity
		        });
				let netPrice = '';
				if(item.productDetails && item.productDetails.pricingData && item.productDetails.pricingData.length) {
					const data = item.productDetails.pricingData.find(itm => itm.item_number === item.productName);
					if (data && data.records && data.records.length && data.records[0].adjusted_unit_price) {
						netPrice = self.props.formatMoney(data.records[0].adjusted_unit_price, 0, ".", ",", false, "");
					}
				}
				productsForGTMAddToCart.push({
					name: item.productDetails.description,
					id: item.productName,
					price: netPrice,
					brand: item.productDetails.brand,
					category: item.productDetails.category,
					variant: undefined,
					quantity: item.qty && item.qty.toString() ,
					dimension70: item.qty && item.productDetails.availabilityData && item.productDetails.availabilityData[0] && item.qty.toString() > item.productDetails.availabilityData[0].availableQty ? 'yes' : 'no', // changingItem.orderNumber ? 'no' : (changingItem.quantity > availableQty ? 'yes' : 'no')
					overpackQuantityRequired: (item.productDetails && item.productDetails.overpackQuantityRequired) || item.overpackQuantityRequired,
					packageQuantity: item.productDetails.packageQuantity || item.packageQuantity
				});
				productsPayloadForCreateOrder.push(JSON.parse(JSON.stringify(item)));
			}
		});
		if (productsForGTMAddToCart.length) {
			let cartCount = 0;
			updatedItems.forEach((itm, index) => {
				cartCount += parseInt(itm.quantity, 10);
			});
			self.props.fireGTMTag('Add to Cart', {
				addToCartLocation: 'cart',
				cartQuantity: cartCount,
				ecommerce: {
					currencyCode: 'USD',
					add: {
						actionField: {
							list: undefined,
							position: undefined,
						},
						products: productsForGTMAddToCart
					}
				}
			});
		}
		self.setState({
			productsPayloadForCreateOrder
		}, () => {
			self.handleAddToCart(updatedItems);
		});
	}

	// event for close dialog
	handleDialog(dialog, flag, event) {
		event && event.preventDefault();
		this.setState({
			['show'+dialog]: false
		}, () => {
			this.setState({
				['show'+dialog]: flag
			})
		})
	}

	componentWillReceiveProps(nextProps) {
        const self = this;
		if(
			(self.props.state.user.selectedAddress && self.props.state.user.selectedAddress !== nextProps.state.user.selectedAddress) ||
			(self.props.state.user.selectedADC && self.props.state.user.selectedADC !== nextProps.state.user.selectedADC) ||
			(self.props.customZipCode && nextProps.customZipCode && self.props.customZipCode !== nextProps.customZipCode)
		) {
			setTimeout(() => {
				self.checkAvailabilityAndAll();
			}, 40);
		}
	}

	callbackAfterAvailability = (availabilityDetails) => {
		if (!availabilityDetails.isAvailabilityByDemandClassPending && !availabilityDetails.isOrderAvailabilityPending) {
			// update store after getting data
			const finalObject = [];
			const products = [];
			this.state.bkpProducts.forEach((item, index) => {
				if(item.productName && !item.isDelete) {
					products.push({
						...item,
						isAddressChanged: true,
					});
				} else {
					products.push({
						...item,
					});
				}
				let availabilityRecord;
				if (item.qty) {
					availabilityRecord = availabilityDetails.orderAvailability && availabilityDetails.orderAvailability.find(orderAvailabilityItem => orderAvailabilityItem.identifier === index + 1 && orderAvailabilityItem.itemNumber === item.productName);
					availabilityRecord = availabilityRecord && this.props.formatOrderAvailabilityData(availabilityRecord);
				} else {
					availabilityRecord = availabilityDetails.availabilityByDemandClass && availabilityDetails.availabilityByDemandClass.find(availabilityByDemandClassItem => availabilityByDemandClassItem.sku === item.productName);
				}
				if(availabilityRecord) {
					finalObject.push({
						sku: item.productName,
						availabilityData: [availabilityRecord],
					});
				}
			});
			this.props.saveAvailabilityOnChangeAddress(finalObject);
			this.setState({
				products
			});
		}
	}

	checkAvailabilityAndAll() {
		const self = this;
		const skuList = [];
		const itemsForOrderAvailability = [];
		const products = [];
		self.state.products.forEach((item, index) => {
			if(item.productName && !item.isDelete) {
				skuList.push({ sku: item.productName.toUpperCase(), demandClass: self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '') });

				if (item.qty) {
					itemsForOrderAvailability.push({
						itemNumber: item.productName,
						identifier: index + 1,
						qty: item.qty,
						shipMethod: 'ADC Truckload',
						arrivalSetName: '',
						itemType: '',
						demandClass: self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '').split("=")[1],
						overrideFlag: 'N',
						quantityUOM: 'EA',
						finalProductionDate: item.productDetails.finalProductionDate ? moment(item.productDetails.finalProductionDate).format('MM/DD/YYYY') : item.productDetails.finalProductionDate,
						agreementNumber: item.agreementNumber
					})
				}
			}
			products.push({
				...JSON.parse(JSON.stringify(item)),
			});
		});
		(skuList.length || itemsForOrderAvailability.length) && self.setState({
			bkpProducts: products
		}, () => {
			const availabilityDetails = {
				isAvailabilityByDemandClassPending: true,
				availabilityByDemandClass: null,
				isOrderAvailabilityPending: true,
				orderAvailability: null
			}
			const data = JSON.parse(self.props.state.user.selectedAddress);
			const zipCode = self.props.customZipCode;
			self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
				if(resp && resp.agentid) {
					if (skuList.length) {
						// Make availability call
						self.props.checkAvailabilityGroupByDemandClass(skuList, `accountNumber=${self.props.getSelectedAccountNumber()}&zipCode=${zipCode}&legacyCustCode=${self.props.getLegacyCustCode()}&warehouseCode=${resp.agentid}`, true, null, '', true, response => {
							availabilityDetails.availabilityByDemandClass = response.responseObject;
							availabilityDetails.isAvailabilityByDemandClassPending = false;
							self.callbackAfterAvailability(availabilityDetails);
						});
					}

					if (itemsForOrderAvailability.length) {
						const payload = {
							accountNumber: self.props.getSelectedAccountNumber(),
							warehouseCode: resp.agentid,
							customerSiteId: data.addressId ? data.addressId :data.SITE_USE_ID,
							requestedDeliveryDate: moment().format('MM/DD/YYYY'),
							orderSource: '',
							zipCode: zipCode,
							state: data.STATE,
							country: data.COUNTRY,
							tradingPartnerId:'',
							dateType:'SHIP',
							items: itemsForOrderAvailability,
						};
						self.props.checkAvailabilityForOrder(payload, orderAvailability => {
							availabilityDetails.orderAvailability = orderAvailability;
							availabilityDetails.isOrderAvailabilityPending = false;
							self.callbackAfterAvailability(availabilityDetails);
						});
					} else if (skuList.length) {
						availabilityDetails.orderAvailability = [];
						availabilityDetails.isOrderAvailabilityPending = false;
						self.callbackAfterAvailability(availabilityDetails);
					}
				}
			});
		});
	}

	componentWillUnmount() {
		if(this.state.updateState) {
			this.props.saveQuickOrderData(JSON.parse(JSON.stringify(this.state)));
		} else {
			this.props.saveQuickOrderData(null);
		}
	}

	componentWillMount() {
		this.props.resetErrorLog();
		const { selectedAccount, selectedPriceSource, defaultSelectedADC, selectedADC, selectedAddress, userDetails } = this.props.state.user;
		let agreementNumber = '';
		if(selectedPriceSource && selectedPriceSource.AGREEMENT_NUMBER) {
			agreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
		}
		const { quickOrderFormData } = this.props.state.order;

		if(quickOrderFormData) {
			this.setState({
				...quickOrderFormData,
				products: quickOrderFormData.products.map(product => product.productName && product.productName.trim() ? product : {...product, agreementNumber})
			});
		} else {
			this.setState({
				products: [
					{productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false},
					{productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false},
					{productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false},
					{productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false},
					{productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false},
					{productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false}
				]
			});
		}

		if (userDetails.isNonGEASsoUser && userDetails.isManRepSsoUser && defaultSelectedADC !== selectedADC) {
			this.props.setDefaultADC(JSON.parse(selectedAddress, selectedAccount.ACCOUNTNUMBER));
		}
	}

	componentDidMount() {
		const { createOrderPayloadBackup } = this.props.state.order;
		if (createOrderPayloadBackup) {
			const updatedCreateOrderPayloadBackup = {
				...createOrderPayloadBackup,
				date: null,
				date2: null,
				date3: null,
			}
			if (updatedCreateOrderPayloadBackup.createOrderForm && updatedCreateOrderPayloadBackup.createOrderForm.params) {
				updatedCreateOrderPayloadBackup.createOrderForm.params = {
					...updatedCreateOrderPayloadBackup.createOrderForm.params,
					requestedDeliveryDate: '',
					requestedDeliveryDate2: '',
					requestedDeliveryDate3: '',
					requestedDeliveryDateError: '',
					requestedDeliveryDate2Error: '',
					requestedDeliveryDate3Error: '',
				}
			}
			this.props.saveCreateOrderPayloadBackup(updatedCreateOrderPayloadBackup);
		}
	}

    handleMoreLines(event) {// add more products and qty
        event.preventDefault();
        var products = this.state.products;
		const { selectedPriceSource } = this.props.state.user;
		let agreementNumber = '';
		if(selectedPriceSource && selectedPriceSource.AGREEMENT_NUMBER) {
			agreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
		}
        products.push({productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false});
		products.push({productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false});
		products.push({productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false});
		products.push({productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false});
		products.push({productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false});
		products.push({productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false});
		products.push({productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false});
		products.push({productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false});
		products.push({productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false});
		products.push({productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false});
        this.setState({
            products: products
        });
    }

    updateQuickOrderState(itemIndex, productDetails) {
		const self = this;
        const products = this.state.products;
        products.map((item, index) => {
            if(index === itemIndex) {
                item.productDetails = productDetails;
                item.productName = productDetails.sku;
				delete item.isImportedFromFile;
				delete item.isAddressChanged;
				delete item.pointValue;
				delete item.perItemPointValue;
				delete item.weight;
				delete item.perItemWeight;
            }
            return null;
        })
        this.setState({
            products: products,
            isDataValid: true
        }, () => {
			if(productDetails && productDetails.pricingData && productDetails.availabilityData) {
				self.fetchPointValueFromPimData();
			} else {
				self.updateOrderPoints();
			}
		});
    }

	debouncedQuantityUpdate = _.debounce(method => method(), 300);

    handleChangeQty(itemIndex, event) {
		const self = this;
        const productqty = event.target.value;
        const products = this.state.products;
		const updatedQuantity = Math.max(1, productqty ? parseInt(productqty, 10) : 1);
		const isQuantityChanged = updatedQuantity !== +products[itemIndex].qty;
		products[itemIndex].qty = updatedQuantity;
        products[itemIndex].qtyError = false;

        self.setState({
            products: products
        }, () => {
			const { method, input } = self.setChangeMethod[itemIndex];
			if (isQuantityChanged) {
				self.debouncedQuantityUpdate(method.bind(this, {
					target: {
						value: input.value
					},
					onChangeOfQuantity: true
				}));
			}
			self.updateOrderPoints();
		});
    }

	handleChangePriceSource(itemIndex, event) {
        var products = this.state.products;
		var agreementNumber = event.target.value;
        products.forEach((item, index) => {
            if(index === itemIndex) {
				if(agreementNumber === 0){
	                item.agreementNumberError = true;
				} else {
					item.agreementNumber = event.target.value;
	                item.agreementNumberError = false;
				}
            }
        });
        this.setState({
            products: products
        });
		const { method, input } = this.setChangeMethod[itemIndex];
		method({
			target: {
				value: input.value
			},
			onChangeOfSalesAgreement: true
		});
    }

    handleChangeProductNumberTextBox(itemIndex, productNumber) {
        var products = this.state.products;
        products.map((item, index) => {
            if(index === itemIndex) {
				if (item.productName !== productNumber) {
					item.qty = '';
				}
                item.productName = productNumber;
                if(productNumber === '') {
                    item.productDetails = null
                }
            }
            return null;
        })
        this.setState({
            products: products
        });
    }

	verifyItemsOfTheCart(event) {
		event.preventDefault();
		const self = this;
        var products = this.state.products,
            formError = false,
            productErrorCount = 0,
			skuList = [];

        products.map((item, index) => {
			if(!item.isDelete) {
	            if(item.productDetails && item.productDetails.status === true && (!item.qty || item.qty < 0)) {
	                item.qtyError = true;
	                formError = true;
	            }
				if(item.productDetails && item.productDetails.status === true && item.agreementNumber === "") {
	                item.agreementNumberError = true;
	                formError = true;
	            }
	            if(item.productDetails && item.productDetails.status === false) {
	                formError = true;
	            }
				if(item.productDetails && (!item.productDetails.pricingData || item.productDetails.pricingData.length === 0)) {
	                formError = true;
	            }
	            if(!item.productName && item.qty !== "") {
	                productErrorCount += 1;
	            }
	            if(!item.productName && item.qty === "") {
	                productErrorCount += 1  ;
	            }
				if(item.overpackQuantityRequired && (item.overpackQuantityRequired.toLowerCase() === "true" || item.overpackQuantityRequired === "1" || item.overpackQuantityRequired.toLowerCase() === "yes") && item.qty ===""){
					item.qtyError = true;
					formError = true;
				}
				skuList.push({sku: item.productName, itemType: 'M'});
			}
            return null;
        });
        this.setState({
            products,
			errorMessage: '',
			isAvailabilityCallCompleted: false,
			isShippingMethodCompleted: false,
			isLast30DaysOrdersCompleted: false,
			isLast60DaysOrdersCompleted: false,
			isBillingPreferencesCallCompleted: false,
			isGetAddressCallCompleted: false,
			isPimCallCompleted: false,
			isPricingCallCompleted: false,
			bulkOrderHoldCallCompleted: false,
			backOrderCallCompleted: false,
        }, () => {
			// This flag we are using in case there are IF items in cart and user is selecting nonIF items on quick order and select combine
			if(!formError) {
	            if(productErrorCount === this.state.products.filter(item => !item.isDelete).length) {
	                formError = true;
	                this.setState({
	                    isDataValid: false
	                });
	            }
	            if(!formError) {
					self.props.checkIfAnyActiveSoldAddress(() => {
						const cartItems = self.props.state.cart && self.props.state.cart.cart && self.props.state.cart.cart.responseObject && self.props.state.cart.cart.responseObject.cartItems;
						// If there are no items in the Cart, add items from Quick Order to the Cart and take the user directly to Create Order.
						if(!cartItems || cartItems.length === 0) {
							self.howToHandleCartItems('delete');
						}
						// If there are items in the Cart, pop-up a msg
						else {
							self.handleDialog('ProductsInTheCartOverlayDialog', true, null);
						}
					});
				}
			}
		});
	}

	handleCreateOrder() {
		const self = this;
		const { selectedAccount, selectedPriceSource } = self.props.state.user;

	    const skuList = [],
			skuListForPim = [];

		const products = JSON.parse(JSON.stringify(self.state.productsPayloadForCreateOrder));
	    products.forEach((item, index) => {
			if(!item.productName) return null;
			skuList.push({
				itemNumber: item.productName,
				identifier: index + 1,
				qty: item.qty,
				shipSet: self.validateFP(item) ? '' : 1,
				shipMethod: 'ADC Truckload',
				arrivalSetName: '',
				itemType: '',
				demandClass: self.props.getSalesAgreementParamForAvailability(item.agreementNumber ? item.agreementNumber.toString() : '').split("=")[1],
				overrideFlag: 'N',
				quantityUOM: 'EA',
				finalProductionDate: item.productDetails.finalProductionDate ? moment(item.productDetails.finalProductionDate).format('MM/DD/YYYY') : item.productDetails.finalProductionDate,
				agreementNumber: item.agreementNumber
			})
			skuListForPim.push(item.productName);
			return null
	    });

		const data = JSON.parse(self.props.state.user.selectedAddress);
		const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
		zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
			if(resp && resp.agentid) {
				// new availability call
				const payload = {
					accountNumber: self.props.getSelectedAccountNumber(),
					warehouseCode: resp.agentid,
					customerSiteId: data.addressId ? data.addressId :data.SITE_USE_ID,
					requestedDeliveryDate: moment().format('MM/DD/YYYY'),// As of now passing the current date as part of WCP-8097
					orderSource: '',
					zipCode: zipCode,
					state: data.STATE,
					country: data.COUNTRY,
					tradingPartnerId:'',
					dateType:'SHIP',
					items: skuList,
				};
				self.props.checkAvailabilityForOrder(payload, response => {
					self.setState({
						isAvailabilityCallCompleted: true,
						availabilityData: response
					}, () => {
						self.callBackBeforeRedirectingToCreateOrder();
					});
				});
			} else {
				self.setState({
					isAvailabilityCallCompleted: true,
				}, () => {
					self.callBackBeforeRedirectingToCreateOrder();
				});
			}
		});

		if(selectedPriceSource.SHIPPING_METHOD) {
			self.props.getShippingMethod(`shippingMethodCode=${selectedPriceSource.SHIPPING_METHOD}`, response => {
				if(!response.status) {
					self.setState({
						errorMessage: response.responseMessage
					});
				} else {
					self.setState({
						isShippingMethodCompleted: true
					}, () => {
						self.callBackBeforeRedirectingToCreateOrder();
					})
				}
			});
		} else {
			self.setState({
				isShippingMethodCompleted: true
			}, () => {
				self.callBackBeforeRedirectingToCreateOrder();
			})
		}

		// Check duplicate PONumber and keep data in store, it can be used to show duplicate message if user select submit order on review order page
		self.setState({
			last30DaysOrders: [],
			isLast30DaysOrdersCompleted: true,
			last60DaysOrders: [],
			isLast60DaysOrdersCompleted: true
		}, () => {
			self.callBackBeforeRedirectingToCreateOrder();
		});
		// self.props.getOrderList(`accountNumber=${self.props.getSelectedAccountNumber()}&requestType=getOrderList&dateRange=30&orderStatus=BOOKED`, response => {
		// 	if(!response.status || !response.responseObject) {
		// 		self.setState({
		// 			last30DaysOrders: [],
		// 			isLast30DaysOrdersCompleted: true
		// 		}, () => {
		// 			self.callBackBeforeRedirectingToCreateOrder();
		// 		})
		// 	} else {
		// 		self.setState({
		// 			last30DaysOrders: response.responseObject,
		// 			isLast30DaysOrdersCompleted: true
		// 		}, () => {
		// 			self.callBackBeforeRedirectingToCreateOrder();
		// 		})
		// 	}
		// });
		// self.props.getOrderList(`accountNumber=${self.props.getSelectedAccountNumber()}&requestType=getOrderList&dateRange=60&orderStatus=BOOKED`, response => {
		// 	if(!response.status || !response.responseObject) {
		// 		self.setState({
		// 			last60DaysOrders: [],
		// 			isLast60DaysOrdersCompleted: true
		// 		}, () => {
		// 			self.callBackBeforeRedirectingToCreateOrder();
		// 		})
		// 	} else {
		// 		self.setState({
		// 			last60DaysOrders: response.responseObject,
		// 			isLast60DaysOrdersCompleted: true
		// 		}, () => {
		// 			self.callBackBeforeRedirectingToCreateOrder();
		// 		})
		// 	}
		// });
		self.props.getBillingReferences(`requestType=getBillingReferences&accountNumber=${self.props.getSelectedAccountNumber()}`, response => {
			// self.props.getBillingReferences(`requestType=getBillingReferences&accountNumber=3589106`, (response) => {
			let responseObj = response.responseObject;
			if(response.status && responseObj && responseObj.length > 0) {
				responseObj.forEach(item => {
					item.requiredFlag = item.required;
					delete item.required;
				});
			}
			self.setState({
				isBillingPreferencesCallCompleted: true
			}, () => {
				self.props.saveBillingReferences(response);
				self.callBackBeforeRedirectingToCreateOrder();
			});
		}, false);

		if (self.props.state.order.isOrderCreatedWithNewAddress) {
			self.props.updateAddressList(() => {
				self.setState({
					isGetAddressCallCompleted: true
				}, () => {
					self.callBackBeforeRedirectingToCreateOrder();
				});
			});
		} else {
			self.setState({
				isGetAddressCallCompleted: true
			}, () => {
				self.callBackBeforeRedirectingToCreateOrder();
			});
		}

	    // make service call to get pim details
		self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
			self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", response => {
				if (response.status) {
					const responseObject = response.responseObject ? response.responseObject : null;
					// update products in state with uncrateInd to use it later for priceOrder service
					let finalProducts = [];
					self.state.productsPayloadForCreateOrder.forEach(item => {
						if(!item.productName) return null;
						let uncrateInd = "N";
						const pimItemData = _.find(responseObject, { item_number: item.productName });
						if(pimItemData && pimItemData.geego_uncrateind) {
							let geego_uncrateind = pimItemData.geego_uncrateind;
							const { selectedAccountsAllPriceSources } = self.props.state.user;
							const record  = selectedAccountsAllPriceSources && _.find(selectedAccountsAllPriceSources.responseObject, {AGREEMENT_NUMBER: selectedPriceSource.AGREEMENT_NUMBER});
							if(record) {
								uncrateInd = record[geego_uncrateind] === "Y"?"Y":"N";
							}
						}
						finalProducts.push({
							...item,
							uncrateInd,
							geego_cust_acct: pimItemData.geego_cust_acct,
							lifeCyclePhase: pimItemData && pimItemData.length> 0 ? pimItemData[0].lifecycle_phase : pimItemData.lifecycle_phase
						});
					});
					self.setState({
						isPimCallCompleted: true,
						pimData: responseObject,
						finalProducts
					}, () => {
						// make service call to get warehouseCode and then make pricing service call
						const accountNumber = selectedAccount.ACCOUNTNUMBER;
					    // const agreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
					   // const data = self.props.getAddressByCategory('SHIP_TO');
					   const data = JSON.parse(self.props.state.user.selectedAddress);
					    let zipCode = data ? data.POSTALCODE.split('-')[0] : '';
					    zipCode && self.props.getShippingAddressesDetails(zipCode, false, 'adc_loc', resp => {
							if (resp && resp.agentid) {
								let payload = {
									accountNumber: accountNumber,
									warehouseCode: resp.agentid,
									shipmentMethod: "ADC Truckload",
									orderTotal: 0,
									priceItems: []
								};

								const listItems = [];
								self.state.finalProducts.forEach(itm => {
									if(itm.productName) {
										payload.priceItems.push({
											itemNumber: itm.productName,
											qty: itm.qty,
											agreementNumber: itm.agreementNumber,
											uncrateInd: itm.uncrateInd,
											grossPointValue: (itm.qty && itm.perItemPointValue) ? (itm.qty * itm.perItemPointValue) : 0,
										});
										listItems.push({
											...itm,
											quantity: itm.qty,
											itemType: 'M',
											item: itm.productName,
										});
									}
								});
								// Make pricing parallel service call
								self.props.makeParallelCallsForCartPrices(
									listItems,
									true,
									true,
									'order',
									null,
									() => {
										const { prices } = self.props.state.order;
										if(prices && prices.length > 0) {
											// Calculate totalcost
											let totalCartCost = 0;
											let products = [];
											self.state.finalProducts.forEach((item, index) => {
												if(!item.productName) return null;
												let price = 0;
												price = _.find(prices, { item_number: item.productName });
												if(price && price.records && price.records.length > 0) {
										  			price = price.records[0].adjusted_unit_price || price.records[0].unit_price
													totalCartCost += price * item.qty;
													item.price = price;
													products.push(item);
												} else {
													price = 0;
												}
										    });
											self.setState({
												finalProducts: products
											}, () => {
												payload = {
													...payload,
													orderTotal: totalCartCost,
													shipToState: JSON.parse(self.props.state.user.selectedAddress).STATE || self.props.getShipToState(),
												}
												// make pricing service call
												self.props.getPriceOrder(payload, "requestType=priceOrder", response => {
													if(!response.status || !response.responseObject) {
														self.props.addErrorLog({
															location: window.location.href,
															errorMessage: messageConstants.PRICE_ORDER_SERVICE_ERROR
														});
													}
													self.setState({
														isPricingCallCompleted: true,
														pricingData: response.responseObject
													}, () => {
														self.callBackBeforeRedirectingToCreateOrder();
													});
												});
											})
										} else {
											 
											browserHistory.push("/error");
										}
									}
								);
							} else {
								self.setState({
									isPricingCallCompleted: true
								}, () => {
									self.callBackBeforeRedirectingToCreateOrder();
								});
							}
					    });
					});
				} else {
					 
					browserHistory.push('/error');
				}
		    })
		})
	}

	getIndexes(array, pickFromArray, value) {
		const indexes = [];
		array.forEach((itm, ind) => {
			if (itm === value)
			  	indexes.push(pickFromArray[ind]);
		});
		return indexes;
    }

	callBackBeforeRedirectingToCreateOrder() {
		const self = this;
		const {
			isAvailabilityCallCompleted,
			isPricingCallCompleted,
			isPimCallCompleted,
			isShippingMethodCompleted,
			availabilityData,
			pimData,
			pricingData,
			isLast30DaysOrdersCompleted,
			isLast60DaysOrdersCompleted,
			last30DaysOrders,
			last60DaysOrders,
			isBillingPreferencesCallCompleted,
			isGetAddressCallCompleted,
		} = this.state;
		const items = [];
		if (isShippingMethodCompleted && isAvailabilityCallCompleted && isPricingCallCompleted && isPimCallCompleted && isLast30DaysOrdersCompleted && isLast60DaysOrdersCompleted && isBillingPreferencesCallCompleted && isGetAddressCallCompleted) {
			self.anyRestrictedItemsAdded(() => {
				self.props.saveBookedOrders(last30DaysOrders.concat(last60DaysOrders));
				const { createOrderPayloadBackup } = self.props.state.order;
				let poNumber = '';
				if(createOrderPayloadBackup && createOrderPayloadBackup.createOrderForm && createOrderPayloadBackup.createOrderForm.params.poNumber) {
					poNumber = createOrderPayloadBackup.createOrderForm.params.poNumber;
				}
				let attributeName = "geego_top_load";
				self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
					if(!resp) {
						attributeName = "geego_no_top_load";
					}
					self.state.finalProducts.forEach((item, index) => {
						let availability = availabilityData.find(itm => itm.itemNumber === item.productName && itm.identifier === index + 1);
						if(!availability && item.productDetails && item.productDetails.availabilityData && item.productDetails.availabilityData[0]) {
							const data = item.productDetails.availabilityData[0];
							if(data) {
								availability = {
									requestedDateQuantity: data.availableQty,
									requestedDeliveryDate: '',
									groupShipDate: '',
									groupShipDateBkp: '',
									shipDate: '',
								};
							}
						}
						let salesPriceData = pricingData ? _.find(pricingData, itm => {
							return itm.itemPrice.item === item.productName && itm.itemPrice.lineIndex === (index + 1).toString() && item.qty.toString() === itm.itemPrice.qty.toString()
						}) : null;
						// If its not available from priceOrder service response then use it from search result pricing service
						// Its already getting saved in .price of products object
						if(!salesPriceData && item.price) {
							salesPriceData = {
								itemPrice: {
									salesPrice: item.price
								}
							}
						}
						const pimItemData = _.find(pimData, { item_number: item.productName });
						if (availability && salesPriceData && pimItemData) {
							const hasReplacement = pimItemData && pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Superseded") !== -1?true:false;
							const replacementSKUs = hasReplacement ? self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Superseded") : [];
							const hasSubstitute = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Substitute") !== -1?true:false;
							const substituteSKUs = hasSubstitute ? self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Substitute") : [];
							const hasUpgrade = pimItemData.relationship_type && pimItemData.relationship_type.indexOf("Up-Sell") !== -1?true:false;
							const upgradeSKUs = hasUpgrade ? self.getIndexes(pimItemData.relationship_type, pimItemData.related_item_number, "Up-Sell") : [];
							const isFedexable = pimItemData.geego_fedexable === "Y" ? true : false;
							let currentPONumber = item.keepOriginalPO === 'Y' ? item.poNumber && item.poNumber.trim() : (item.poNumber || '').toUpperCase().trim();
							let isQuickOrderPO = false;
							if (!currentPONumber) {
								currentPONumber = poNumber.trim();
							} else {
								isQuickOrderPO = true;
							}
							let newItem = {
								packageName: item.packageName ? item.packageName.toUpperCase() : '',
								item: item.productName.trim(),
								itemDescription: item.itemDescription || item.productDetails.description,
								itemType: item.itemType || (item.productDetails.availabilityData && item.productDetails.availabilityData[0] && item.productDetails.availabilityData[0].itemType),
								quantity: item.qty,
								quantityError: '',
								imagePath:item.productDetails.imagePath||item.imagePath,
								overpackQuantityRequired : (item.productDetails && item.productDetails.overpackQuantityRequired) || item.overpackQuantityRequired,
								packageQuantity : item.productDetails.packageQuantity || item.packageQuantity,
								price: salesPriceData.itemPrice.salesPrice,
								agreementNumber: item.agreementNumber,
								originalAgreementNumber: item.agreementNumber,
								relatedServices: self.props.prepareBagItems(salesPriceData),
								// this can be used to calculate orderTotal without making pricing service call again before orderPrice service
								originalPrice: item.price,
								pointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * item.qty) : 0.00,
								perItemPointValue: pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00,
								geego_cust_acct: pimItemData.geego_cust_acct,
								lifeCyclePhase : pimItemData && pimItemData.length> 0 ? pimItemData[0].lifecycle_phase : pimItemData.lifecycle_phase,

								// Top load indicator value for backup
								perItemPointValueTopLoad: pimItemData['geego_top_load'] && pimItemData['geego_top_load'] !== 'NULL' ? parseFloat(pimItemData['geego_top_load']) : 0.00,
								// No top load indicator value for backup
								perItemPointValueNoTopLoad: pimItemData['geego_no_top_load'] && pimItemData['geego_no_top_load'] !== 'NULL' ? parseFloat(pimItemData['geego_no_top_load']) : 0.00,
								brand: pimItemData['geego_brand'],
								category: pimItemData['item_catalog_group'],
	
								geego_final_production_date: pimItemData['geego_final_production_date'],
								geego_distribution_start_date: pimItemData['geego_distribution_start_date'],
								geego_uncrateind: pimItemData.geego_uncrateind,
	
								weight: self.props.getOrderWeightFromPimData(pimItemData, item.qty),
								perItemWeight: self.props.getOrderWeightFromPimData(pimItemData, 1),
								hasReplacement,
								hasSubstitute,
								hasUpgrade,
								replacementSKUs,
								substituteSKUs,
								upgradeSKUs,
								isFedexable,
								uncrateInd: item.uncrateInd,
								originalUncrateInd: item.uncrateInd,
								requestedDeliveryDate: 'delivery1',
								originalDelivery: 'delivery1',
								requestedDeliveryDateBackUp: 'delivery1',
								keepOriginalPrice: item.keepOriginalPrice,
								pricingDate: item.orderDate ? self.props.formatDate(item.orderDate, 'MM/DD/YYYY') : moment().format('MM/DD/YYYY'),
								keepOriginalPO: item.keepOriginalPO,
								poNumber: currentPONumber,
								isQuickOrderPO,
								// originalPoNumber: item.keepOriginalPO === 'Y' ? item.poNumber : '',
								originalOrderNumber: item.orderNumber,
	
								redirectFrom: 'quickorder',
							};
							// pass modifiers from order details data if ordernumber and line number exists
							if (item.orderNumber && item.orderLineId) {
								newItem = {
									...newItem,
									lineNo: item.lineNumber,
									orderLineId: item.orderLineId,
									modifiers: self.props.getDataFromParallelCall(item.orderLineId, item.orderNumber, 'modifiers', []),
									originalItem: self.props.getDataFromParallelCall(item.orderLineId, item.orderNumber, 'originalItem'),
									pimLifeCycleError : newItem.lifeCyclePhase === "Near End of Life" ? true : false
								};
							}
							items.push(newItem);
						}
					});
					if(items.length === 0) {
							self.setState({
							  errorMessage: "Error occured while fetching pricing"
						  })
						} else {
						const data = JSON.parse(self.props.state.user.selectedAddress);
						const zipCode = data ? data.POSTALCODE.split('-')[0] : '';
						zipCode && self.props.getShippingAddressesDetails(zipCode, false, 'sds_loc', resp => {
							if (resp && resp.agentid) {
								const products = [];
								items.forEach(item => {
									products.push({
										name: item.itemDescription,
										id: item.item,
										price: self.props.formatMoney(item.price, 0, ".", ",", false, ""),
										brand: item.brand,
										category: item.category,
										variant: undefined,
										quantity: item.quantity,
										dimension70: item.quantity > item.availability ? 'yes' : 'no',
										dimension79: 1,
										dimension80: item.uncrateInd === 'Y' ? 'uncrated' : 'crated',
										dimension82: undefined
									});
								});
								self.props.fireGTMTag('Checkout Step', {
									shippingMethod: resp.isThisADCLOC ? "ADC Truckload" : "SDS Delivery",
									ecommerce:{
										currencyCode: 'USD',
										checkout: {
											actionField: {
												step: '1'
											},
											products
										}
									}
								});
								self.props.saveCreateOrderPayload({ items });
								self.setState({
									updateState: false,
								}, () => {
									browserHistory.push("/order/createOrder");
								});
							}
						});
					}
				});
			});
		}
    }

	handleImportAction(event) {
		const self = this;
		self.handleDialog('ImportFileConfirmOverlayDialog', false, event);
		document.getElementById('file-input').click();
	}

	handleFileUpload(e) {
        e.preventDefault();
        var self = this,
            files = e.target.files;
        if (files.length > 0) {
            self.setState({
                fileUploadStatusMessage: 'Please wait until file is uploading.....',
                fileUploadStatus: true,
                fileUploadErrorMessage: ''
            });
            var file = files[0],
                reader = new FileReader();
            reader.addEventListener('loadend', function (e) {
				const { userDetails } = self.props.state.user;
                fetch(s3BucketAPIBaseURL, {
                    method: "POST",
					headers: {
						'Content-Type': 'application/json',
						"Authorization": `${userDetails.jwt}${userDetails.sso}`
					},
                    body: JSON.stringify({
                        name:  "CustomerNet/tmp/" + file.name,
                        type: file.type
                    })
                }).then(function (response) {
                    return response.json();
                }).then(function (json) {
					var list = [];
                    list.push({
                        fileName: file.name,
                        fileURL: json.uploadURL
                    });
					self.setState({
						fileName: file.name
                    });
                    return fetch(json.uploadURL, {
                        method: "PUT",
                        body: new Blob([reader.result], {
                            type: file.type
                        })
                    })
                }).then(function () {
                    self.setState({
                        fileUploadStatusMessage: 'File is uploaded successfully.',
                        fileUploadStatus: false,
                        fileUploadErrorMessage: ''
                    }, () => {
						self.fileUploadInput.value = null;
						self.fetchContentOfFile();
					});
                });
            });
            reader.readAsArrayBuffer(file);
        } else {
            self.setState({
                fileUploadStatusMessage: '',
                fileUploadStatus: false,
                fileUploadErrorMessage: ''
            });
        }
    }

	fetchContentOfFile() {
		const self = this;
		self.props.getProductsFromS3(`requestType=getProductsFromS3&s3FileName=${encodeURIComponent(self.state.fileName)}`, resp => {
			if(resp.status && resp.responseObject) {
				if(resp.responseObject.length) {
					// make all items uppercase
					resp.responseObject.forEach(item => {
						item.sku = item.sku.toUpperCase();
					});
					const items = resp.responseObject.map(item => item.sku);
					self.props.getItemsSuggestionDetails(items, '&needAllItems=Y', itemDetails => {
						if(itemDetails) {
							// manipulate responseobject with getProductsFromS3 and as getItems is filtering all items which are not customer ready.
							// we need to assume if item is not coming in getItems that is not customerready.
							const updatedResponseObject = [];
							resp.responseObject.forEach(item => {
								// is item is coming in getItems then push it else push getProductsFromS3 item
								const data = itemDetails.find(itm => item.sku === itm.sku);
								if (data) {
									updatedResponseObject.push({
										...data,
										orderQty: item.orderQty,
										agreementNumber: item.agreementNumber,
										poNumber: item.poNumber,
										correctData: true
									});
								} else {
									// if not found in getItems it means its not customer ready so we will keep adding
									// it as it is without adding pricing and other details eventually it will show
									// red border for such items
									updatedResponseObject.push(item);
								}
								
							});
							const { selectedPriceSource } = this.props.state.user;
							let agreementNumber = '';
							if(selectedPriceSource && selectedPriceSource.AGREEMENT_NUMBER) {
								agreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
							}
							const products = [];
							const skuListForPim = [];
							const skuList = [];
							const skuListForPricing = [];
							self.state.products.forEach(item => {
								if(item.productName) {
									products.push(item);
									const currentSA = item.agreementNumber ? item.agreementNumber.toString() : '';
									skuList.push({ sku: item.productName.toUpperCase(), qty: item.qty, agreementNumber: currentSA, demandClass: self.props.getSalesAgreementParamForAvailability(currentSA || '').split("=")[1] });
									skuListForPricing.push({sku: item.productName.toUpperCase(), agreementNumber: currentSA});
									skuListForPim.push({
										productName: item.productName.toUpperCase(),
										qty: item.qty
									});
								}
							});
							const { selectedAccountsAllPriceSources } = self.props.state.user;
							updatedResponseObject.forEach(item => {
								let currentSA = agreementNumber;
								// check if user has entered any agreement number in excel sheet then we have to find it in existing all price source. if it is there then we have to use it
								// if it is invalid then we have to use header selected SA
								if (item.agreementNumber && selectedAccountsAllPriceSources.responseObject.find(itm => itm.AGREEMENT_NUMBER.toString() === item.agreementNumber.toString())) {
									currentSA = item.agreementNumber.toString();
								}
								const product = {
									productName: item.sku.toUpperCase(),
									imagePath:item.imagePath,
		 						    itemDescription:item.description,
									qty: item.overpackQuantityRequired && (item.overpackQuantityRequired.toLowerCase() === "true" || item.overpackQuantityRequired === "1" || item.overpackQuantityRequired.toLowerCase() === "yes") ? "" : item.orderQty,
									productDetails: null,
									
									agreementNumber: currentSA,
									poNumber: item.poNumber ? item.poNumber.toUpperCase() : '',
									qtyError: false,
									agreementNumberError: false,
									isImportedFromFile: true,
									overpackQuantityRequired : item.overpackQuantityRequired,
									packageQuantity: item.packageQuantity
								};
								products.push(product);
								if (item.correctData) {
									skuList.push({ sku: item.sku.toUpperCase(), qty: product.qty, agreementNumber: currentSA, demandClass: self.props.getSalesAgreementParamForAvailability(currentSA || '').split("=")[1] });
									skuListForPricing.push({sku: item.sku.toUpperCase(), agreementNumber: currentSA});
									skuListForPim.push({
										productName: item.sku.toUpperCase(),
										qty: item.orderQty
									});
								}
							});
							self.props.fireGTMTag('Quick Order Import', {
								numProductsImported: skuListForPricing.length,
								productSkusImported: skuListForPricing.filter(itm => itm.sku).join(',')
							});
							self.setState({
								bkpProducts: products,
								isAvailabilityCallCompleted: false,
								isPricingCallCompleted: false,
								isPimCallCompleted: false,
								isItemOrderabilityCallCompleted: false,
							}, () => {
								const data = JSON.parse(self.props.state.user.selectedAddress);
								const zipCode = self.props.customZipCode;
								zipCode && self.props.getShippingAddressesDetails(zipCode, true, 'adc_loc', resp => {
									if(resp && resp.agentid) {
										const orderAvailabilityPayload = {
											accountNumber: self.props.getSelectedAccountNumber(),
											warehouseCode: resp.agentid,
											customerSiteId: data.addressId ? data.addressId : data.SITE_USE_ID,
											requestedDeliveryDate: moment().format('MM/DD/YYYY'),
											orderSource: '',
											zipCode: zipCode,
											state: data.STATE,
											country: data.COUNTRY,
											tradingPartnerId:'',
											dateType:'SHIP',
											items: skuList.map((skuItem, index) => ({
												itemNumber: skuItem.sku,
												identifier: index + 1,
												qty: skuItem.qty || 1,
												shipSet: '',
												shipMethod: 'ADC Truckload',
												arrivalSetName: '',
												itemType: '',
												demandClass: skuItem.demandClass,
												overrideFlag: 'N',
												quantityUOM: 'EA',
												finalProductionDate: null,
												// finalProductionDate: skuItem.productDetails.finalProductionDate ? moment(skuItem.productDetails.finalProductionDate).format('MM/DD/YYYY') : skuItem.productDetails.finalProductionDate,
												agreementNumber: skuItem.agreementNumber
											}))
										}
										// Make availability call
										self.props.checkAvailabilityForOrder(orderAvailabilityPayload, orderAvailabilityData => {
											self.setState({
												isAvailabilityCallCompleted: true,
												availabilityDataImportedFile: orderAvailabilityData.map(orderAvailabilityItem => self.props.formatOrderAvailabilityData(orderAvailabilityItem))
											}, () => {
												self.callBackAfterParallelCalls();
											});
										});
										self.props.checkItemOrderabilityInBatches(skuList.map(item => `'${item.sku}'`), '', null, true, response => {
											self.setState({
												isItemOrderabilityCallCompleted: true,
												itemOrderabilityDataImportedFile: response
											}, () => {
												self.callBackAfterParallelCalls();
											});
										});
									}
								});
								const skuListForPricingArrayByAgreementNumber = [];
								const groupBySA = _.groupBy(skuListForPricing, 'agreementNumber');
								Object.keys(groupBySA).forEach(item => {
									skuListForPricingArrayByAgreementNumber.push({
										agreementNumber: item.toString(),
										list: groupBySA[item].map(itm => itm.sku)
									});
								})
								self.setState({
									numberOfParallelCallForProductPrices: skuListForPricingArrayByAgreementNumber.length,
									saveCompletedNumberOfParallelCallForProductPrices: 0,
									pricingDataImportedFile: []
								}, () => {
									// now for quick order page first make product pricing service call to calculate total cost
									const pricingEffectiveDate = moment().tz('America/New_York').format('YYYYMMDD');
									skuListForPricingArrayByAgreementNumber.forEach(item => {
										self.props.checkPricesForSearchResult({
											account_number: self.props.getSelectedAccountNumber(),
											pricing_effective_date: pricingEffectiveDate,
											sa_number: item.agreementNumber,
											item_numbers: item.list
										}, true, false, response => {
											const finalPricing = [];
											response = processPricingResponse(response);
											response.responseObject && response.responseObject.items && response.responseObject.items.forEach(item => {
												item.records = _.filter(item.records, { orderable: "Y"});
												if(item.records.length === 0) {
													item = null;
												} else {
													finalPricing.push(item);
												}
											});
											 
											let pricingDataImportedFile = self.state.pricingDataImportedFile;
											pricingDataImportedFile = finalPricing.length > 0 ?pricingDataImportedFile.concat(finalPricing):pricingDataImportedFile;
											self.setState({
												pricingDataImportedFile,
												saveCompletedNumberOfParallelCallForProductPrices: self.state.saveCompletedNumberOfParallelCallForProductPrices + 1
											}, () => {
												 
												if (self.state.saveCompletedNumberOfParallelCallForProductPrices === self.state.numberOfParallelCallForProductPrices) {
													self.setState({
														isPricingCallCompleted: true,
														pricingDataImportedFile: {
															items: pricingDataImportedFile
														}
													}, () => {
														self.callBackAfterParallelCalls();
													});
												}
											});
										});
									});
								});

								self.fetchPimData(skuListForPim, () => {
									const pimDataByItem = self.state.pimDataByItem;
									const { bkpProducts } = self.state;
									bkpProducts.forEach((item) => {
										const record = pimDataByItem.find(itm => item.productName === itm.productName);
										if(record) {
											item.itemType = record.pimData.itemType;
										}
									});
									self.setState({
										isPimDataCallCompleted: true,
										bkpProducts
									}, () => {
										self.callBackAfterParallelCalls();
									});
								});
							});
						} else {
							 
							browserHistory.push('/error');
						}
					});
				} else {
					self.setState({
						fileUploadStatusMessage: 'There are no items in the file.',
						fileUploadStatus: false,
						fileUploadErrorMessage: ''
					});
				}
			} else {
				 
				browserHistory.push('/error');
			}
		});
	}

	callBackAfterParallelCalls() {
		 
		const self = this;
		const { isAvailabilityCallCompleted, isPricingCallCompleted, isItemOrderabilityCallCompleted, isPimDataCallCompleted, availabilityDataImportedFile, pricingDataImportedFile, itemOrderabilityDataImportedFile } = self.state;
		if(isAvailabilityCallCompleted && isPricingCallCompleted && isItemOrderabilityCallCompleted && isPimDataCallCompleted) {
			const finalObject = [];
			self.state.bkpProducts.forEach(item => {
				const pricingRecords = [];
                pricingDataImportedFile.items && pricingDataImportedFile.items.map(itm => {
                    const rec = itm.records.filter(it => it.sa_number == item.agreementNumber.toString() && it.item_number == item.productName);
                    if(rec && rec.length > 0) {
                        pricingRecords.push(itm);
                    }});
				const availabilityRecord = availabilityDataImportedFile && availabilityDataImportedFile.find(availData => availData.sku ===  item.productName && itemOrderabilityDataImportedFile.find(orderability => orderability.ITEM === availData.sku && orderability.ITEM_ORDERABILITY_FLAG === 'Y'));
				let newRow = {};
				if(availabilityRecord) {
					newRow = {
                        ...newRow,
                        sku: item.productName,
                        agreementNumber: item.agreementNumber,
                        availabilityData: [availabilityRecord]
                    }}

                if(pricingRecords && pricingRecords.length > 0) {
                    newRow = {
                        ...newRow,
                        sku: item.productName,
                        agreementNumber: item.agreementNumber,
                        pricingData: {
                            items: [pricingRecords[0]]
                        }
                    }
				}
				if (JSON.stringify(newRow) !== '{}') {
					finalObject.push(newRow);
				}
			});
			self.props.saveAvailabilityPricingOfImportedFile(finalObject);
			self.setState({
				products: self.state.bkpProducts
			}, () => {
				self.fetchPointValueFromPimData();
			})
		}
	}

	updateOrderPoints() {
		const self = this;
		const { products } = self.state;
		let pointValue = 0.00;
		let orderWeight = 0.00;
		products.forEach(item => {
			if(item.productName && item.perItemPointValue && item.qty && item.qty > 0) {
				pointValue += (item.qty * item.perItemPointValue);
				orderWeight += (item.qty * item.perItemWeight);
			}
		});
		pointValue = parseFloat(pointValue).toFixed(2);
		orderWeight	= parseFloat(orderWeight).toFixed(2);
		self.setState({
			pointValue,
			orderWeight,
		});
	}

	fetchPimData(skuListForPim, callback) {
		const self = this;
		if(skuListForPim.length > 0) {
			// make service call to get pim details
			let attributeName = "geego_top_load";
			self.props.getOrgAttributesByAttributeName("Top Load Indicator", resp => {
				if(!resp) {
					attributeName = "geego_no_top_load";
				}
				const skuList = skuListForPim.map(itm => itm.productName);
				self.props.getPIMItemInfo(skuList, "requestType=getPIMItemInfo", resp => {
					if (resp.status) {
						const pimData = resp.responseObject;
						const pimDataByItem = self.state.pimDataByItem;
						skuListForPim.forEach((item) => {
							const pimItemData = _.find(pimData, { item_number: item.productName });
							if (pimItemData) {
								const pointValue = pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * item.qty) : 0.00;
								const perItemPointValue = pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00;
								const weight = self.props.getOrderWeightFromPimData(pimItemData, item.qty);
								const perItemWeight = self.props.getOrderWeightFromPimData(pimItemData, 1);
								const itemType = self.props.getItemType(item.productName, pimItemData);
								item.pointValue = pointValue;
								item.perItemPointValue = perItemPointValue;
								item.weight = weight;
								item.perItemWeight = perItemWeight;
								item.availEta = pimItemData.geego_distribution_start_date;
								item.finalProductionDate = pimItemData.geego_final_production_date;
								pimDataByItem.push({
									productName: item.productName,
									pimData: {
										pointValue,
										perItemPointValue,
										weight,
										perItemWeight,
										itemType,
										geego_cust_acct: pimItemData.geego_cust_acct,
										availEta: item.availEta,
										lifeCyclePhase: pimItemData && pimItemData.length> 0 ? pimItemData[0].lifecycle_phase : pimItemData.lifecycle_phase,
										finalProductionDate: item.finalProductionDate
									}
								});
							}
						});
						self.setState({
							pimDataByItem
						}, () => {
							callback && callback();
						})
					} else {
						 
						browserHistory.push('/error');
					}
				});
			});
		}
	}

	fetchPointValueFromPimData() {
		const self = this;
		const skuListForPim = [];
		self.state.products.forEach((item, index) => {
			if(item.productName && item.productDetails && item.productDetails.availabilityData && item.productDetails.pricingData && !self.state.pimDataByItem.find(itm => itm.productName === item.productName)) {
				skuListForPim.push(item.productName);
			}
		});
		if(skuListForPim.length > 0) {
			// make service call to get pim details
			let attributeName = "geego_top_load";
			self.props.getOrgAttributesByAttributeName("Top Load Indicator", respnse => {
				if(!respnse) {
					attributeName = "geego_no_top_load";
				}
				self.props.getPIMItemInfo(skuListForPim, "requestType=getPIMItemInfo", resp => {
					if (resp.status) {
						const pimData = resp.responseObject;
						const products = self.state.products;
						const pimDataByItem = self.state.pimDataByItem;
						products.forEach((item) => {
							delete item.isImportedFromFile;
							delete item.isAddressChanged;
							const pimItemData = _.find(pimData, { item_number: item.productName });
							if (pimItemData) {
								const pointValue = pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName] * item.qty) : 0.00;
								const perItemPointValue = pimItemData[attributeName] && pimItemData[attributeName] !== 'NULL' ? parseFloat(pimItemData[attributeName]) : 0.00;
								const weight = self.props.getOrderWeightFromPimData(pimItemData, item.qty);
								const perItemWeight = self.props.getOrderWeightFromPimData(pimItemData, 1);
								const availEta = pimItemData.geego_distribution_start_date;
								const lifeCyclePhase = pimItemData && pimItemData.length> 0 ? pimItemData[0].lifecycle_phase : pimItemData.lifecycle_phase
								item.pointValue = pointValue;
								item.perItemPointValue = perItemPointValue;
								item.weight = weight;
								item.perItemWeight = perItemWeight;
								item.availEta = availEta;
								item.lifeCyclePhase = lifeCyclePhase;
								item.finalProductionDate = pimItemData.geego_final_production_date;
								pimDataByItem.push({
									productName: item.productName,
									pimData: {
										pointValue,
										perItemPointValue,
										weight,
										perItemWeight,
										geego_cust_acct: pimItemData.geego_cust_acct,
										availEta: availEta,
										lifeCyclePhase,
										finalProductionDate: item.finalProductionDate,
									}
								});
							}
						});
						self.setState({
							products,
							pimDataByItem
						}, () => {
							self.updateOrderPoints();
						});
					} else {
						 
						browserHistory.push('/error');
					}
				});
			});
		} else {
			// Read it from existing data saved in state
			const products = self.state.products;
			const pimDataByItem = self.state.pimDataByItem;
			products.forEach((item) => {
				const pimItemData = _.find(pimDataByItem, { productName: item.productName });
				if (pimItemData && pimItemData.pimData) {
					item.pointValue = pimItemData.pimData.pointValue;
					item.perItemPointValue = pimItemData.pimData.perItemPointValue;
					item.weight = pimItemData.pimData.weight;
					item.perItemWeight = pimItemData.pimData.perItemWeight;
				    item.availEta = pimItemData.pimData.geego_distribution_start_date;
					item.lifeCyclePhase = pimItemData && pimItemData.pimData ? pimItemData.pimData.lifecycle_phase : ""
				}
				delete item.isImportedFromFile;
				delete item.isAddressChanged;
			});
			self.setState({
				products
			}, () => {
				self.updateOrderPoints();
			});
		}
	}

	validateFP(item) {
		const self = this;
		const pimInfo = (self.state.pimDataByItem && self.state.pimDataByItem.find(pimItem => pimItem.productName === item.productName));
		return pimInfo ? self.props.checkIfFP({
			finalProductionDate: pimInfo && pimInfo.pimData && pimInfo.pimData.finalProductionDate && pimInfo.pimData.finalProductionDate !== "NULL" ? pimInfo.pimData.finalProductionDate : null,
			availableQty: item.productDetails.availabilityData[0].availableQty,
			etaDate: item.productDetails.availabilityData[0].etaDate && moment(item.productDetails.availabilityData[0].etaDate, "MM/DD/YYYY").format("YYYY-MM-DD"),
			requestedQuantity: item.qty
		}) : false;
	}

	validateFDD(item) {
		const self = this;
		const pimInfo = (self.state.pimDataByItem && self.state.pimDataByItem.find(pimItem => pimItem.productName === item.productName));
		return pimInfo ? self.props.validateFDD({
			firstDistributionDate: pimInfo && pimInfo.pimData && pimInfo.pimData.availEta && pimInfo.pimData.availEta !== "NULL" ? pimInfo.pimData.availEta : null,
			availableQty: item.productDetails.availabilityData[0].availableQty,
			intransitQty: item.productDetails.availabilityData[0].intransitQty,
			etaDate: item.productDetails.availabilityData[0].etaDate && moment(item.productDetails.availabilityData[0].etaDate, "MM/DD/YYYY").format("YYYY-MM-DD")
		}) : item;
	}

	handleDelete(indx, event) {
		event.preventDefault();
		const self = this;
		const updatedItem = JSON.parse(JSON.stringify(self.state.products));
		updatedItem.forEach((item, index) => {
			if(index === indx) {
				item.isDelete = true;
				item.qty = 0;
			}
		});
			self.setState({
				products: updatedItem
			}, () => {
				self.updateOrderPoints();
			});
	}

	handleRemoveAll(event) {
        event.preventDefault();
		const { selectedPriceSource } = this.props.state.user;
		let agreementNumber = '';
		if(selectedPriceSource && selectedPriceSource.AGREEMENT_NUMBER) {
			agreementNumber = selectedPriceSource.AGREEMENT_NUMBER;
		}
		this.setState({
			products: [],
			pointValue: 0.00,
			orderWeight: 0.00,
			isAvailabilityCallCompleted: false,
	        isPricingCallCompleted: false,
	        isPimCallCompleted: false,
		}, () => {
			this.setState({
				products: [
					{productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false},
					{productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false},
					{productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false},
					{productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false},
					{productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false},
					{productName: "", poNumber: "", poNumberError: false, qty: "", productDetails: null, agreementNumber: agreementNumber, qtyError: false, agreementNumberError: false}
				]
			});
		});
    }

	onChangePONumber(index, sku, event) {
		const self = this;
		const { products } = self.state;
		products[index].poNumber = event.target.value.toUpperCase();
		products[index].poNumberError = false;
		self.setState({
			products
		});
	}

	validatePONumberCharactersItemLevel(index, event) {
		const self = this;
		const { products } = self.state;
		products[index].poNumberError = !self.props.isValidPONumberCharacter(event);
		self.setState({
			products
		});
	}

	manipulateClipBoardOfPONumber(index, whichItem, event) {
		this.props.manipulateClipBoardOfPONumber((e) => {
			this.validatePONumberCharactersItemLevel(index, e);
		}, undefined, undefined, event);
	}

	getSelectedAddressParams() {
		const queryString = `&country=US&zip=${this.props.customZipCode}`;
		return queryString;
	}

	anyRestrictedItemsAdded(callback) {
		const self = this;
		const restrictedItems = self.state.finalProducts.filter(item => self.props.isAnyModelIsRestrictedInSelectedAccount(item));
		if (restrictedItems.length === 0) {
			callback();
		} else {
			self.setState({
				genericDialogHeading: "Action",
				genericDialogText: 'Please remove below models before proceed. GEA is not currently selling these models to this account.',
				extraParagraph: restrictedItems.map(item => item.productName).join(', '),
				modalButtons: 'ok'
			}, () => {
				self.handleDialog("GenericOverlayDialog", true);
			});
		}
	}

    render() {
		const self = this;
		const toolTipContent = `The ETA is when the REQUESTED QUANTITY will be available from the GE Appliances ADC for an order placed today.<br/><br/>
						<b>6+ mos:</b> Model is currently in production, but demand exceeds all planned supply. “6+ mos.” indicates that we cannot provide an exact ETA date. The system estimate for availability under these conditions is greater than 6 months from today.<br/><br/>
						<b>FP:</b> Model is past the final production date and there is no more supply being produced. “FP” indicates that the model cannot be supplied from the serving warehouse and cannot be ordered.`;
		const { pointValue, orderWeight, pimDataByItem , products} = self.state;
		const {cartBackOrders} = self.props.state.cart;
		const isPricingAccess = self.props.isResponsibilityExists("Price");
		const showCreateOrderButton = self.props.isResponsibilityExists("Create New Order") && isPricingAccess;
		const selectedAccountsAllPriceSources = self.props.getSalesAgreementList();
		let isThereAnyModelIsRestrictedInSelectedAccount = false;
		let isBackOrderItemOnCart = false;
        return (
            <div>
                <div style={{width: '90%'}} className="push">
					<div className="pull-right">
						<a href="" className="greenBtn pull-right" onClick={(event) => this.handleDialog('ImportFileConfirmOverlayDialog', true, event)}>Import File</a>
						<div className="clear" />
						{this.state.fileUploadErrorMessage?<p className="red"><b>{this.state.fileUploadErrorMessage}</b></p>:null}
						{this.state.fileUploadStatusMessage?<p className="bold">{this.state.fileUploadStatusMessage}</p>:null}
					</div>
                    <h1 className="pageTitle">Quick Order</h1>
                </div>
				<input ref={(input) => this.fileUploadInput = input} id="file-input" style={{display: 'none'}} accept=".xlsx, .xls, .csv" onChange={this.handleFileUpload.bind(this)} type="file" />
				<ChangeZipCode
					saveCustomADC={self.props.saveCustomADC}
					customADC={self.props.customADC}
					selectedAccount={self.props.state.user.selectedAccount}
					getShippingAddressesDetails={this.props.getShippingAddressesDetails}
					acceptNumbersOnly={this.props.acceptNumbersOnly}
					handleSelectZipCode={this.props.saveCustomZipCode}
					zipCode={this.props.customZipCode}
					typeOfAccount={self.props.getSelectedAccountType()}
					showInStockFilter={false}
				/>
				<form className="quickOrderForm" name="quickOrderForm" id="quickOrderForm" onSubmit={(e) => e.preventDefault()}>
                    <div className="largePush">
						<div className="orderPoints">
							Order Points: {parseFloat(pointValue).toFixed(2)} &nbsp; &nbsp; Order Weight: {parseFloat(orderWeight).toFixed(2)}
						</div>
                         <p><b>Enter Products</b></p>
                         {(this.state.isDataValid === false)
                             ?<p className="red"><strong>Enter at least one valid product number and qty.</strong></p>
                             :null
                         }
						 <p className="bold red">{this.state.errorMessage}</p>
                        <table className="dataTable quickOrderTable" style={{width: '100%'}}>
                            <thead>
                                <tr>
									<th className="actions">
										<a className="deleteAllLink" href="" onClick={this.handleRemoveAll.bind(this)}>✗</a>
									</th>
                                    <th>Product</th>
									<th className="text-center">Available<br/>Now</th>
									<th className="text-center">Available<br/>on ETA</th>
									<th className="text-center"><span className="inline-block" style={{ width: 'max-content' }}>ETA at</span>ADC<a className="questionMarkIcon" href="" onClick={this.handleDialog.bind(this, "ToolTipOverlayDialog", true)}><img src="../images/icon-question-mark.png" width={12} height={11} alt="What is this?" title="What is this?" /></a></th>
									{isPricingAccess && <th className="text-center">Net&nbsp;Price<br />(each)</th>}
                                    <th>Qty</th>
									<th>Sales Agreement</th>
									<th>PO Number</th>
                                </tr>
                            </thead>
                            <tbody>
                             {this.state.products.map((item, index) => {
								if (item.isDelete) return null;
								let data = {
									availableQty: null,
									intransitQty: null,
									etaDate: null,
								};
								const pimInfo = pimDataByItem.filter((itm)=> itm.productName === item.productName )
								const pimInfoValue = pimInfo && pimInfo.length>0 ? pimInfo[0].pimData : {};
								let lifeCyclePhaseValue = pimInfoValue && pimInfoValue.lifeCyclePhase && pimInfoValue.lifeCyclePhase === "Near End of Life" ? true : false;
								const isCartItem = cartBackOrders && cartBackOrders.responseObject && cartBackOrders.responseObject.cartItems ? cartBackOrders.responseObject.cartItems  : [] ;
								const isBackOrderItem = isCartItem && isCartItem.length>0 && isCartItem.filter((itm)=>itm.item === item.productName && itm.isBackOrder)
								if(isBackOrderItem && isBackOrderItem.length>0 && lifeCyclePhaseValue ){
									isBackOrderItemOnCart = true
								}
								if(item.productDetails && item.productDetails.availabilityData && item.productDetails.availabilityData.length > 0) {
									data = {
			 							availableQty: item.productDetails.availabilityData[0].availableQty,
			 							intransitQty: item.productDetails.availabilityData[0].intransitQty,
			 							etaDate: item.productDetails.availabilityData[0].etaDate,
			 						};

			 						if(self.validateFP(item)) {
			 							data.intransitQty = null;
			 							data.etaDate = 'FP';
			 						} else {
			 							data = self.validateFDD(item);
			 						}

									if (item.qty && data.availableQty >= item.qty) {
										data.etaDate = moment().format('MM/DD/YYYY');
									}
								}
								let netPrice = '';
								if(item.productDetails && item.productDetails.pricingData && item.productDetails.pricingData.length) {
									const data = item.productDetails.pricingData.find(itm => itm.item_number === item.productName);
									if (data && data.records && data.records.length && data.records[0].adjusted_unit_price) {
										netPrice = self.props.formatMoney(data.records[0].adjusted_unit_price, 0, ".", ",", false, "$");
									}
								}
								const pimData = pimDataByItem.find(itm => itm.productName === item.productName);
								const isCurrentModelIsRestrictedInSelectedAccount = self.props.isAnyModelIsRestrictedInSelectedAccount(pimData && pimData.pimData);
								if (isCurrentModelIsRestrictedInSelectedAccount) {
									isThereAnyModelIsRestrictedInSelectedAccount = true;
								}
								let optionOverPackValues = [];
								if(item.productDetails && item.productDetails.overpackQuantityRequired && (item.productDetails.overpackQuantityRequired === "1" || item.productDetails.overpackQuantityRequired.toLowerCase() === "true" || item.productDetails.overpackQuantityRequired.toLowerCase() == "yes") ){
										if(item.productDetails.packageQuantity && item.productDetails.packageQuantity > 1){
											optionOverPackValues[0]= "select";
											for(let i=1 ; i<=20 ; i++){
												optionOverPackValues[i] = (item.productDetails.packageQuantity * (i));
											}
										}
									}
								const itemAvailabilityError = item.productDetails && item.productDetails.availabilityData && item.productDetails.availabilityData[0] && item.productDetails.availabilityData[0].message &&
									this.props.state.order.itemAvailabilityFailedMsgList.some(itemAvailabilityFailedMsg => item.productDetails.availabilityData[0].message.toLowerCase().includes(itemAvailabilityFailedMsg.toLowerCase())) && `This item cannot be ordered from ${item.productDetails.availabilityData[0].warehouseCode}`;
                                return <tr key={index} id={"quickOrderTableRow"+index}>
									<td className="delete">
										<a onClick={this.handleDelete.bind(this, index)} className="deleteLink" href="#">✗</a>
									</td>
                                     <td className={((item.productDetails && item.productDetails.status === false) || (item.productDetails && (!item.productDetails.pricingData || item.productDetails.pricingData.length === 0)) || isCurrentModelIsRestrictedInSelectedAccount)|| (isBackOrderItem && isBackOrderItem.length>0 &&  pimInfoValue.lifeCyclePhase === "Near End of Life") ?"error":""}>
                                         <AccountNumberAutoSuggests
											checkAvailabilityAndOrderability={this.props.checkAvailabilityAndOrderability}
											selectedAddressParams={self.getSelectedAddressParams()}
											getShippingAddressesDetails={this.props.getShippingAddressesDetails}
										 	value={item.productName}
											setChangeMethod={(method, input) => this.setChangeMethod[index] = {method, input} }
											selectedPriceSource={item.agreementNumber}
											updateQuickOrderState={this.updateQuickOrderState.bind(this)}
											onChangeProductNumberTextBox={this.handleChangeProductNumberTextBox.bind(this)}
											itemIndex={index}
											zipCode={self.props.customZipCode}
											legacyCustCode={this.props.getLegacyCustCode()}
											itemType={item.itemType}
											isImportedFromFile={item.isImportedFromFile}
											isAddressChanged={item.isAddressChanged}
											width='auto'
											whichPage="quickorder"
											getSalesAgreementParamForAvailability={this.props.getSalesAgreementParamForAvailability}
											itemDetails={item}
											checkAvailabilityForOrder={this.props.checkAvailabilityForOrder}
											formatOrderAvailabilityData={this.props.formatOrderAvailabilityData}
										/>
                                        {(item.productDetails && item.productDetails.status === false) || (item.productDetails)
                                            ?<span className="quickOrderTableRowError">You must enter a valid full or partial product number.</span>
                                            :null
                                        }
										{isCurrentModelIsRestrictedInSelectedAccount &&
											<span className="red">Please remove the highlighted model. GEA is not currently selling this model to this account.</span>
										}
										{itemAvailabilityError && <p className="red mb-0">{itemAvailabilityError}</p>}
                                    </td>
									<td className="text-center">
										{item.productDetails && item.productDetails.availabilityData && item.productDetails.availabilityData.length > 0 &&
											<span>
												{pimInfoValue.lifeCyclePhase !== "Near End of Life" ? self.props.checkAvailability(data.availableQty, data.firstDistributionDate): ""}
											</span>
										}
									</td>
									<td className="text-center">
										{item.productDetails && item.productDetails.availabilityData && item.productDetails.availabilityData.length > 0 && (!+item.productDetails.availabilityData[0].availableQty || item.productDetails.availabilityData[0].availableQty < item.qty) &&
											<span>
												{pimInfoValue.lifeCyclePhase !== "Near End of Life" ? data.intransitQty : "NLA"}
											</span>
										}
									</td>
									<td className="text-center">
										{item.productDetails && item.productDetails.availabilityData && item.productDetails.availabilityData.length > 0 &&
											<span>
												{pimInfoValue.lifeCyclePhase !== "Near End of Life" ? (moment(data.firstDistributionDate).isAfter(moment())? data.firstDistributionDate : data.etaDate && (moment(data.etaDate).isValid() ? moment(data.etaDate).format("MM/DD/YYYY") : data.etaDate) ): ""}
											</span>
										}
									</td>
									{isPricingAccess && <td className="text-center">{netPrice}</td>}
									{optionOverPackValues.length > 0?
										   <td className="quantity">
												<select className={item.qtyError?"error":"row_quantity"} 
												onChange={this.handleChangeQty.bind(this,index)} 
												name="row1_quantity"
												disabled={item.originalOrderNumber ? true : false}>
													{optionOverPackValues.map((val, index)=>{
															return <option 
																	id={"quantity"+index}
																	key={index} 
																	value={val}>{val}</option>
														}) }
												</select>
											</td>:
                                    <td>
                                       <input onPaste={this.props.doNothing} type="text"
										 key={index} onChange={this.handleChangeQty.bind(this,index)} 
										 onKeyPress={this.props.acceptNumbersOnly.bind(this)} 
										 className={item.qtyError?"error":"row_quantity"} 
										 size={3} name="row1_quantity" value={item.qty} />
                                    </td>}
									<td>
										<select style={{width: '100%'}} value={item.agreementNumber ? item.agreementNumber : ""} className={item.agreementNumberError?"error":"row_quote"} onChange={this.handleChangePriceSource.bind(this, index)} name="row1_quote" disabled={selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject && selectedAccountsAllPriceSources.responseObject.length === 1}>
											<option value="">Select Sales Agreement</option>
											{selectedAccountsAllPriceSources && selectedAccountsAllPriceSources.responseObject.filter((itm)=>{
												return itm.PRICE_LIST_NAME != "APPLIANCES - BLEM LOAD PRICE LIST" && itm.AGREEMENT_TYPE !== 'GEA Parts'
												}).map((item, ind) => {
												return <option value={item.AGREEMENT_NUMBER} key={ind}>{item.DISPLAY_AGREEMENT_NAME}</option>
											})}
										</select>
									</td>
									<td>
                                        <input onKeyPress={this.validatePONumberCharactersItemLevel.bind(this, index)} onPaste={this.props.manipulateClipBoardOfPONumber.bind(this, this.onChangePONumber, index, item.productName)} type="text" key={index} onChange={this.onChangePONumber.bind(this, index, item.productName)} className={item.poNumberError?'error':''} name="row1_poNumber" value={item.poNumber} />
                                    </td>
                                 </tr>
                             })}
                            </tbody>
                        </table>
                        {/* This table is populated on-load by the same function that adds additional lines - createQuickOrderTableRow(); */}
                        <div>
							<div style={{float: 'left'}}>
								<a className="bold noUnderline uppercase" href="" id="addQuickOrderTableRow" onClick={this.handleMoreLines.bind(this)} >+ <u>ADD more lines</u></a>
							</div>
							<p className="textRight">
								{ showCreateOrderButton && !self.props.isSelectedAccountNumberAsIs && !isThereAnyModelIsRestrictedInSelectedAccount && <input type="submit" className="blueButton uppercase" id="addQuickOrderTableRow" value="Create Order"  disabled = {isBackOrderItemOnCart  } onClick={this.verifyItemsOfTheCart.bind(this)} />}
							</p>
							<div className="clear" />
                        </div>
                    </div>
                </form>
				{this.state.showToolTipOverlayDialog?<ToolTipOverlayDialog title="ETA" content={toolTipContent} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showProductsInTheCartOverlayDialog?<ProductsInTheCartOverlayDialog howToHandleCartItems={this.howToHandleCartItems.bind(this)} handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
				{this.state.showImportFileConfirmOverlayDialog?<ImportFileConfirmOverlayDialog handleDialog={this.handleDialog.bind(this)} handleImportAction={this.handleImportAction.bind(this)} showDialog={true} />:null}
				{this.state.showGenericOverlayDialog?<GenericOverlayDialog genericDialogHeading={this.state.genericDialogHeading} genericDialogText={this.state.genericDialogText} buttons="ok" extraParagraph={this.state.extraParagraph} flag="GenericOverlayDialog" handleDialog={this.handleDialog.bind(this)} showDialog={true} />:null}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return { state };
};

const mapDispatchToProps = (dispatch) => ({
	getPriceOrder: (payload, params, response) => dispatch(getPriceOrder(payload, params, response)),
	getPIMItemInfo: (payload, params, response) => dispatch(getPIMItemInfo(payload, params, response)),
	saveCreateOrderPayload: (payload) => dispatch(saveCreateOrderPayload(payload)),
	saveCreateOrderPayloadBackup: (data) => dispatch(saveCreateOrderPayloadBackup(data)),
	getOrderList: (queryStringParams, callback) => dispatch(getOrderList(queryStringParams, callback)),
    saveBookedOrders: (data) => dispatch(saveBookedOrders(data)),
	getBillingReferences: (queryString, callback, errorRedirection) => dispatch(getBillingReferences(queryString, callback, errorRedirection)),
    saveBillingReferences: (data) => dispatch(saveBillingReferences(data)),
	saveAvailabilityOnChangeAddress: (data) => dispatch(saveAvailabilityOnChangeAddress(data)),
	getShippingMethod: (queryString, callback) => dispatch(getShippingMethod(queryString, callback)),
	saveToCart: (data) => dispatch(saveToCart(data)),
	saveQuickOrderData: (data) => dispatch(saveQuickOrderData(data)),
	saveAvailabilityPricingOfImportedFile: (data) => dispatch(saveAvailabilityPricingOfImportedFile(data)),
	addToCart: (payload, callback) => dispatch(addToCart(payload, callback)),
	getProductsFromS3: (queryString, callback) => dispatch(getProductsFromS3(queryString, callback)),
	checkPricesForSearchResult: (data, showLoader, saveToStore, callback) => dispatch(checkPricesForSearchResult(data, showLoader, saveToStore, callback)),
	getSearchKeywordSuggestionList: (payload, callback) => dispatch(getSearchKeywordSuggestionList(payload, callback)),
	resetErrorLog: () => dispatch(resetErrorLog()),
});

QuickOrderForm = connect(mapStateToProps, mapDispatchToProps)(QuickOrderForm);
export default QuickOrderForm;



// WEBPACK FOOTER //
// ./src/App/components/PostLogin/Order/quickOrderForm.js